import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Short on purpose: a tall empty box reads as "something failed to load". */
export const EmptyState = ({ icon: Icon, title, description, action, className }: EmptyStateProps) => (
  <div className={cn('flex flex-col items-center justify-center gap-2 py-6 px-4 text-center', className)}>
    {Icon && (
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-tint text-muted" aria-hidden>
        <Icon size={20} />
      </span>
    )}
    <h3 className="text-card font-semibold text-ink">{title}</h3>
    {description && <p className="text-body text-muted">{description}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
